var map = {
	"./Blue/0.png": 36475,
	"./Blue/1.png": 29362,
	"./Blue/10.png": 81420,
	"./Blue/11.png": 92062,
	"./Blue/2.png": 68166,
	"./Blue/3.png": 27649,
	"./Blue/4.png": 37383,
	"./Blue/5.png": 70043,
	"./Blue/6.png": 47202,
	"./Blue/7.png": 4487,
	"./Blue/8.png": 9013,
	"./Blue/9.png": 17839,
	"./Gray/0.png": 84655,
	"./Gray/1.png": 72507,
	"./Gray/10.png": 37236,
	"./Gray/11.png": 2649,
	"./Gray/2.png": 66525,
	"./Gray/3.png": 18280,
	"./Gray/4.png": 31930,
	"./Gray/5.png": 72088,
	"./Gray/6.png": 20809,
	"./Gray/7.png": 18180,
	"./Gray/8.png": 64843,
	"./Gray/9.png": 54730,
	"./Green/0.png": 43928,
	"./Green/1.png": 1416,
	"./Green/10.png": 46149,
	"./Green/11.png": 31008,
	"./Green/2.png": 63319,
	"./Green/3.png": 30918,
	"./Green/4.png": 57555,
	"./Green/5.png": 93080,
	"./Green/6.png": 3514,
	"./Green/7.png": 91264,
	"./Green/8.png": 25182,
	"./Green/9.png": 60448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47361;